import { useRepositoryInfiniteQuery } from '@mews-commander/data-access';
import { getFullName } from '@mews-commander/utils';
import { getResourceName } from './utils';
import { useGetAllResourcesQuery } from './useGetAllResourcesQuery';

const PAGE_SIZE = 10;

export const useSearchReservationsInfiniteQuery = (searchToken: string) => {
    const { data: resourcesData } = useGetAllResourcesQuery();

    return useRepositoryInfiniteQuery(
        'reservations',
        'searchNew',
        ({ pageParam }) => ({
            searchToken,
            startIndex: pageParam,
            count: PAGE_SIZE,
        }),
        {
            enabled: !!searchToken && !!resourcesData,
            initialPageParam: 0,
            getNextPageParam: (lastPage, allPages) =>
                (lastPage.reservations ?? []).length < PAGE_SIZE ? undefined : allPages.length * PAGE_SIZE,
            select: (queryData) =>
                queryData.pages
                    .flatMap((page) => page.reservations ?? [])
                    .map((reservation) => ({
                        ...reservation,
                        customerName: getFullName(reservation.customer),
                        resourceName: resourcesData
                            ? getResourceName(
                                  reservation,
                                  resourcesData.resources,
                                  resourcesData.resourceCategories,
                                  resourcesData.resourceCategoryAssignments
                              )
                            : '',
                    })),
        }
    );
};
